/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19"
        height="15.24"
        viewBox="0 0 19 15.24"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M19 3.7a3.68 3.68 0 0 0-7.33-.5H0v12h16.6V7.1A3.7 3.7 0 0 0 19 3.7Zm-3.4 10.54H1v-1.21h14.6Zm0-2.21H1v-1.21h14.6Zm0-2.21H1V4.2h10.67a3.67 3.67 0 0 0 3.64 3.18 1.32 1.32 0 0 0 .28 0Zm-.29-3.43A2.69 2.69 0 1 1 18 3.7a2.68 2.68 0 0 1-2.69 2.69ZM1.95 8.61h3.9v-3.2h-3.9Zm2.9-2.21v1.21h-1.9V6.4Zm10.91-4.46V4l.66-.67.71.71-1.86 1.87-1.89-1.87.71-.71.67.67V1.94Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'CreditCardWithArrowDownIcon';

export default Icon;
